import { FormApi } from 'final-form';
import { useEffect } from 'react';
import { useState } from 'react';
import { resetPasswordRequestApi } from '../../apis';
import { handleApiError } from '../../helpers';
import { RESET_PASSWORD_REDIRECT_URL, TIME_OUT_DURATION } from '../../helpers/constants';
import { RequestPasswordResetDto } from '../../interfaces';
import useResetError from '../useResetError';

const useRequestPasswordReset = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const { error, setError } = useResetError();

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, TIME_OUT_DURATION);
    }
  }, [success]);

  const onSubmitHandler = (payload: RequestPasswordResetDto) => {
    setSubmitting(true);
    setError(null);
    resetPasswordRequestApi(payload)
      .then(() => {
        setSubmitting(false);
        setSuccess(true);
        setEmail(payload.email);
      })
      .catch((error) => {
        setSubmitting(false);
        setError(handleApiError(error));
      });
  };

  return { onSubmitHandler, submitting, success, error, email };
};

export default useRequestPasswordReset;
